import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { NOINDEX_PRIVATE_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import { getAuthToken } from "../../services/authApi";
import { getMyLibrary } from "../../services/libraryApi";
import "./library.css";

export default function LibraryPurchaseSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id") || "";
  const [libraryWarmup, setLibraryWarmup] = useState("");

  usePageSeo({
    ...NOINDEX_PRIVATE_SEO,
    title: "Purchase complete | Treydora Library",
    description: "Your digital library purchase was successful.",
  });

  useEffect(() => {
    if (!getAuthToken()) return;
    let cancelled = false;
    (async () => {
      try {
        await getMyLibrary();
        if (!cancelled) {
          setLibraryWarmup("Your library list was refreshed in the background. Open My Library if titles are still catching up.");
        }
      } catch {
        if (!cancelled) {
          setLibraryWarmup("Open My Library in a moment — access is confirmed by Stripe, not this page.");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="lib-storefront">
      <div className="lib-inner" style={{ paddingTop: 72, paddingBottom: 96, maxWidth: 560 }}>
        <header className="lib-sec-head">
          <span className="lib-sec-eyebrow lib-sec-eyebrow--blue">Treydora Library</span>
          <h1 className="lib-sec-title lib-serif">Thank you</h1>
          <p className="lib-sec-desc">
            Your digital edition purchase is complete. Your library access is granted after payment confirmation (usually
            within a few seconds). If items do not appear, refresh My Library in a moment.
          </p>
          {libraryWarmup ? (
            <p className="lib-sec-desc" style={{ opacity: 0.85, fontSize: "0.92rem", marginTop: 8 }}>
              {libraryWarmup}
            </p>
          ) : null}
          {sessionId ? (
            <p className="lib-sec-desc" style={{ opacity: 0.75, fontSize: "0.9rem" }}>
              Reference: <code style={{ wordBreak: "break-all" }}>{sessionId}</code>
            </p>
          ) : null}
        </header>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 28 }}>
          <Link to="/dashboard/library" className="lib-btn lib-btn--gold lib-btn--sm" style={{ textDecoration: "none" }}>
            Go to My Library
          </Link>
          <Link to="/library" className="lib-btn lib-btn--primary lib-btn--sm" style={{ textDecoration: "none" }}>
            Return to Library
          </Link>
        </div>
      </div>
    </div>
  );
}
